import { Flex, Text } from '@chakra-ui/react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useBlockchainProvider } from 'src/providers/Blockchain/blockchainProvider';
import { CopyAddressIcon } from 'src/utils/icons/copyAddress';
import { CopyAddressConfirmedIcon } from 'src/utils/icons/copyAddressConfirmed';
import { HashSmallIcon } from 'src/utils/icons/hashSmall';

export const ContractHelper = () => {
	const { t } = useTranslation();
	const [animating, setAnimating] = useState<boolean>(false);

	const { contracts } = useBlockchainProvider();

	const copyAddressToClipboard = () => {
		if (!contracts.hash) {
			return;
		}

		return;
		const animationTime = 1000;
		navigator.clipboard.writeText(contracts.hash!.address);
		setAnimating(true);
		setTimeout(() => setAnimating(false), animationTime);
	};

	return (
		<Flex
			alignItems="center"
			gridGap="5px"
			color="white"
			fontSize="12px"
		>
			<Text fontWeight="bold">{t('hashupInfo.contract')}:</Text>
			<HashSmallIcon />
			<Flex
				gridGap="6px"
				alignItems="center"
				onClick={copyAddressToClipboard}
			>
				<Text>{contracts.hash ? t('comingSoon') : 'Change network'}</Text>
				{animating ? <CopyAddressConfirmedIcon width="13px" /> : <CopyAddressIcon width="13px" />}
			</Flex>
		</Flex>
	);
};
